const APPOINTMENT_ERRORS: Record<number, string> = {
  401: 'Неверный код из SMS, запросите новый и повторите попытку',
  409: 'Извините, выбранная дата и время уже недоступны.',
  422: 'Проверьте правильность введённых данных.',
};

const DEFAULT_ERROR = 'Что-то пошло не так, попробуйте позже.';

export const getAppointmentErrorMessage = (status: number): string =>
  APPOINTMENT_ERRORS[status] ?? DEFAULT_ERROR;
